export default {"src":"/_next/static/media/logo-white.3e910c30.svg","height":400,"width":1496,"blurWidth":0,"blurHeight":0};